import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { toDinero, toNumberLossy } from "../../../../currency/currencyLib"
import { StatisticGraph } from "../../../../../shared/components/statistic/StatisticGraph"
import { useSupplier } from "../../../../supplier/supplierHooks"
import { CompanyReportsHomeQuery, fetchMeetingServicePurchases } from "../companyReportsHomeApi"

export function MeetingServicesPurchasesStat({ periodInDays }: { periodInDays: number }) {
    const { supplierId } = useSupplier()

    const { data } = useApiQuery(fetchMeetingServicePurchases, {
        queryName: CompanyReportsHomeQuery.MEETING_SERVICE_PURCHASES,
        dependencies: {
            companyId: supplierId,
            periodInDays,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
    })
    if (!data) return null

    return (
        <StatisticGraph
            changeInPercentage={data?.reportSummary?.changeInPercentage}
            labels={data.meetingServicePurchases.map((entry) => entry.date)}
            datasets={data.meetingServicePurchases.map((entry) =>
                toNumberLossy(toDinero(entry.purchaseSummary.totalAmount)),
            )}
            title={data?.reportSummary?.changeInPercentage}
        />
    )
}
